import { MODEL } from "../model";

export const getPublishedCourses = async () => {
  if (!MODEL.data || !Array.isArray(MODEL.data.courses)) {
    console.error("MODEL.data.courses is undefined or not an array");
    return [];
  }
  //
  return (
    MODEL.data.courses.filter((course) => course.isPublished === true) || []
  );
};

export const getPublishedCoursesByCategory = async (category) => {
  // console.log({category});
  // console.log(MODEL.data.courses[0]);

  // Find the course that matches the category
  const coursesByCategory = MODEL.data.courses.filter(
    (course) =>
      course.category === category.trim() && course.isPublished === true
  );

  // console.log({ coursesByCategory });

  if (coursesByCategory.length <= 0) {
    // Return an empty array or a specific message if the category is not found
    return { category, data: [] }; // or return null; depending on your use case
  }

  return { category, data: coursesByCategory };
};

export const getFeaturedPublishedCourses = async () => {
  const response = await MODEL.data.courses
    .filter(
      (course) => course.isFeatured === true && course.isPublished === true
    )
    .slice(-5);
  return response;
};
export const getPublishedCategoryCourseDetailBySlugORID = async (
  category,
  courseSlug
) => {
  let categoryData;

  if (!isNaN(courseSlug)) {
    // If courseSlug is a number, search by ID
    categoryData = MODEL.data.courses.find(
      (course) =>
        course.category === category &&
        parseInt(course.id) === parseInt(courseSlug) &&
        course.isPublished === true
    );
  } else {
    // If courseSlug is a string, search by slug
    categoryData = MODEL.data.courses.find(
      (course) =>
        course.category === category &&
        course.slug === courseSlug &&
        course.isPublished === true
    );
  }

  return categoryData || {};
};
